
export default {
	buddies: {},
	buddyList: [],
}